import React from 'react'
import Banner from '../components/Landing/Banner'
import SectionTwo from '../components/Landing/SectionTwo'
import SectionThree from '../components/Landing/SectionThree'
import SectionFour from '../components/Landing/SectionFour'
import SectionFive from '../components/Landing/SectionFive'
import SectionSix from '../components/Landing/SectionSix'
import SectionSeven from '../components/Landing/SectionSeven'
import SectionEight from '../components/Landing/SectionEight'

const Landing = () => {
    return (
        <>
            <Banner />
            <SectionTwo />
            <SectionThree />
            <SectionFour />
            <SectionFive />
            {/* <SectionSix /> */}
            <SectionSeven />
            <SectionEight />
        </>
    )
}

export default Landing